import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type { NormalizedInterval } from 'date-fns'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export class AwardsEarnedMathsRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductMs = 'maths'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return { product, uiScope, scopedStudents, ...stats }
  }

  makeStatsRequests(product: LegacyProductMs, scope: SchoolScope | StudentsScope, period: NormalizedInterval) {
    const { studentEvents } = this
    return RSVP.hash({
      awardsEarnedTotals: studentEvents.awardsEarnedTotals(product, scope, period),
      awardsEarnedHistory: studentEvents.awardsEarnedHistory(product, scope, period),
    })
  }
}

export default AwardsEarnedMathsRoute
